import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setStep, clearState } from '../store/byoSlice'

const Review = ({ data }) => {
  const { step, color, material, materialSelected, addons, addonSeleted } = useSelector((state) => state.byo)
  const dispatch = useDispatch()

  let nextStep = step + 1
  if (step === 2 && data.addons.length === 0) {
    nextStep = 4
    if (data.addons2.length == 0) nextStep = 5
  } else if (step === 3 && data.addons2.length == 0)
    nextStep = 5

  let previousStep = step - 1
  if (step === 5 && data.addons2.length == 0) {
    previousStep = 3
    if (data.addons.length === 0) previousStep = 2
  } else if (step === 4 && data.addons.length === 0)
    previousStep = 2

  const variantIndex = data.metafields.material.length * color + material
  const selectedVariant = data.variants[variantIndex]
  let basePrice = parseFloat(data.metafields.color[color].list_price)
  let total = parseFloat(data.metafields.color[color].list_price) + parseFloat(data.metafields.material[material].list_price)
  if (variantIndex < data.variants.length) total = selectedVariant.data.price / 100.0
  data.addons.map((addon) => {
    addon.variants.map((variant) => {
      if (addons.filter((a) => a.productId === addon.product.id && a.variantId === variant.data.id).length) total += variant.data.price / 100.0
    })
  })
  data.addons2.map((addon) => {
    addon.variants.map((variant) => {
      if (addons.filter((a) => a.productId === addon.product.id && a.variantId === variant.data.id).length) total += variant.data.price / 100.0
    })
  })
  const addonLineItem = (step, addon, index) => {
    let dataAddons = step == 3 ? data.addons : data.addons2
    const product = dataAddons.filter((a) => a.product.id === addon.productId).length > 0 ? dataAddons.filter((a) => a.product.id === addon.productId)[0] : null
    if (product) {
      const variant = product.variants.filter((variant) => variant.data.id === addon.variantId)[0]
      if (typeof variant != 'undefined' && variant) {
        const variantImage = variant.data.featured_image ? variant.data.featured_image.src : (product.product.featured_image ? product.product.featured_image : null)
        return <div className='flex items-center justify-between border-b border-puffco-grey-7 py-2 px-6' key={`${step}-addon-${index}`}>
          <span className='font-bold inline-flex items-center text-sm'>
            {variantImage && <img className='w-[3.75rem] h-[3.75rem] object-cotain mr-2' src={variantImage} />}
            {variant.data.name}
          </span>
          <span className='font-mono text-sm'>${parseFloat(variant.data.price / 100.0).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.00', '')}</span>
        </div>
      }
    }
  }
  const makeid = (length) => {
    let result = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const charactersLength = characters.length
    let counter = 0
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
      counter += 1
    }
    return result
  }
  const addToCart = () => {
    const bunldeId = `bundle-${makeid(10)}`
    const bunldeData = [
      {
        "image": data.metafields.color[color].option_image,
        "title": data.metafields.color[color].display_name,
        "price": data.metafields.color[color].list_price
      },
      {
        "image": data.metafields.material[material].option_image,
        "title": data.metafields.material[material].display_name,
        "price": data.metafields.material[material].list_price
      }
    ]
    if (data.metafields.material[material].display_name.toLowerCase().includes('proxy')) {
      bunldeData.push(
        {
          "image": data.free_case_image,
          "title": "Free Case",
          "price": 0
        }
      )
    }
    const lineItems = [
      {
        "properties": {
          "bunldeId": bunldeId,
          "bundles": JSON.stringify(bunldeData)
        },
        "id": parseInt(selectedVariant.data.id),
        "quantity": 1
      },
    ]
    data.addons.map((addon) => {
      addon.variants.map((variant) => {
        if (addons.filter((a) => a.productId === addon.product.id && a.variantId === variant.data.id).length)
          lineItems.push(
            {
              // "customAttributes": [
              //   {
              //     "key": "bunldeId",
              //     "value": bunldeId
              //   }
              // ],
              "id": parseInt(variant.data.id),
              "quantity": 1
            }
          )
      })
    })
    data.addons2.map((addon) => {
      addon.variants.map((variant) => {
        if (addons.filter((a) => a.productId === addon.product.id && a.variantId === variant.data.id).length)
          lineItems.push(
            {
              // "customAttributes": [
              //   {
              //     "key": "bunldeId",
              //     "value": bunldeId
              //   }
              // ],
              "id": parseInt(variant.data.id),
              "quantity": 1
            }
          )
      })
    })

    window.addLineItems((cart) => {
      document.querySelector('[data-atc]').innerHTML = `${data.checkmarkIcon} ADDED`;
      document.querySelector('[data-atb').innerHTML = data.ctaLabel; 
      setTimeout(() => {
        document.querySelector('[data-atc]').style.display = 'none';
        document.querySelector('[data-atb]').style.display = 'block'; 
        document.querySelector('[data-atb]').href = data.ctaLink;
        document.querySelector('[data-atb]').onclick = () => {
          window.location.href = `${data.ctaLink}`;
        };
      }, 2000);
    }, lineItems, true);
    
  }

  return (
    <div className='pt-[1.875rem] lg:pt-[3.75rem] pb-16 px-6 h-full flex flex-col justify-between'>
          <div className='pb-[2.75rem]  pt-2 hidden lg:flex justify-between items-center'>
            <a href='/' className='inline-block'>
              <img src={data.puffcoLogo} alt="Puffco logo" className='h-fit max-h-[40px] w-fit max-w-[23px]' />
            </a>
            <a href={data.ctaLink} className='inline-block text-xs underline underline-offset-4'>
              {data.ctaLabel}
            </a>
          </div>
      <div className='flex flex-col justify-between max-h-[calc(100%-5rem)] -mx-6 order-1 lg:order-none'>
        <div className='px-6'>
          <p className='uppercase text-base font-mono mb-2'>Review</p>
          {data.steps[step - 1] && data.steps[step - 1].title && <div className='text-2xl leading-10 mb-6 !font-semibold tracking-[2px]' dangerouslySetInnerHTML={{ __html: data.steps[step - 1].title }} />}
        </div>
        <div className='h-[calc(100%-3rem)] overflow-auto border-t border-puffco-grey-7'>
          {
            data.metafields.color[color] &&
            <div className='flex items-center justify-between border-b border-puffco-grey-7 py-2 px-6'>
              <span className='font-bold inline-flex items-center text-sm'>
                {data.metafields.color[color].option_image && <img className='w-[3.75rem] h-[3.75rem] object-cotain mr-2' src={data.metafields.color[color].option_image} />}
                {data.metafields.color[color].display_name}
              </span>
              {
              
                  (<span className='font-mono ddd d text-sm'>${parseFloat(data.metafields.color[color].list_price).toLocaleString(undefined, { maximumFractionDigits: 2 })}</span>)
              }
            </div>
          }
          {
            data.metafields.material[material] &&
            <div className='flex items-center justify-between border-b border-puffco-grey-7 py-2 px-6'>
              <span className='font-bold inline-flex items-center text-sm'>
                {data.metafields.material[material].option_image && <img className='w-[3.75rem] h-[3.75rem] object-cotain mr-2' src={data.metafields.material[material].option_image} />}
                {data.metafields.material[material].display_name}
              </span>
              <span className='font-mono text-sm'>${parseFloat(data.metafields.material[material].list_price).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.00', '')}</span>
            </div>
          }
          {
            data.metafields.material[material].display_name.toLowerCase().includes('proxy') &&
            <div className='flex items-center justify-between border-b border-puffco-grey-7 py-2 px-6'>
              <span className='font-bold inline-flex items-center text-sm'>
                <img className='w-[3.75rem] h-[3.75rem] object-cotain mr-2' src={data.free_case_image} alt='Free Case' width='40' height='40' loading='lazy' />
                Free Case
              </span>
              <span className='font-mono text-sm'>$0</span>
            </div>
          }
          {
            addons.length > 0 && addons.map((addon, index) => addonLineItem(3, addon, index))
          }
          {
            addons.length > 0 && addons.map((addon, index) => addonLineItem(4, addon, index))
          }
        </div>
        <div className='px-6'>
          <button className='bg-puffco-yellow hover:bg-[#E6E6E6] transition-all duration-300 ease-in-out text-black w-full mt-10 rounded-md h-14 inline-flex items-center justify-center font-mono text-sm' onClick={() => addToCart()} data-atc>
            {
              data.metafields.material[material].display_name.toLowerCase().includes('proxy') ?
                `ADD TO CART - $${parseFloat(total).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.00', '')}`
                :
                `ADD TO CART - $${parseFloat(total).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.00', '')}`
            }
          </button>
          <button className='bg-puffco-yellow hover:bg-[#E6E6E6] transition-all duration-300 ease-in-out text-black w-full mt-4  uppercase rounded-md h-14 inline-flex items-center justify-center font-mono hidden text-sm' data-atb>
          </button>
            
                      <div className='flex items-center flex-wrap justify-center mt-3 text-puffco-light-black-3 text-[0.75rem] leading-6'>
            or 4 interest-free payments of ${parseFloat(total / 4).toLocaleString(undefined, { maximumFractionDigits: 2 })}
            <svg className='ml-1.5' width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.96658 11C7.19992 11 7.39725 10.9193 7.55859 10.758C7.71947 10.5971 7.79992 10.4 7.79992 10.1667C7.79992 9.93334 7.71947 9.73623 7.55859 9.57534C7.39725 9.41401 7.19992 9.33334 6.96658 9.33334C6.73325 9.33334 6.53592 9.41401 6.37459 9.57534C6.2137 9.73623 6.13325 9.93334 6.13325 10.1667C6.13325 10.4 6.2137 10.5971 6.37459 10.758C6.53592 10.9193 6.73325 11 6.96658 11ZM6.36659 8.43334H7.59992C7.59992 8.06668 7.6417 7.77779 7.72525 7.56668C7.80836 7.35557 8.04436 7.06668 8.43325 6.70001C8.72214 6.41112 8.94992 6.13601 9.11658 5.87468C9.28325 5.61379 9.36658 5.30001 9.36658 4.93334C9.36658 4.31112 9.13881 3.83334 8.68325 3.50001C8.2277 3.16668 7.68881 3.00001 7.06659 3.00001C6.43325 3.00001 5.91947 3.16668 5.52525 3.50001C5.13059 3.83334 4.85547 4.23334 4.69992 4.70001L5.79992 5.13334C5.85547 4.93334 5.98058 4.71668 6.17525 4.48334C6.36947 4.25001 6.66658 4.13334 7.06659 4.13334C7.42214 4.13334 7.68881 4.23045 7.86658 4.42468C8.04436 4.61934 8.13325 4.83334 8.13325 5.06668C8.13325 5.2889 8.06658 5.49712 7.93325 5.69134C7.79992 5.88601 7.63325 6.06668 7.43325 6.23334C6.94436 6.66668 6.64436 6.99445 6.53325 7.21668C6.42214 7.4389 6.36659 7.84445 6.36659 8.43334ZM6.99992 13.6667C6.0777 13.6667 5.21103 13.4916 4.39992 13.1413C3.58881 12.7916 2.88325 12.3167 2.28325 11.7167C1.68325 11.1167 1.20836 10.4111 0.858585 9.60001C0.508363 8.7889 0.333252 7.92223 0.333252 7.00001C0.333252 6.07779 0.508363 5.21112 0.858585 4.40001C1.20836 3.5889 1.68325 2.88334 2.28325 2.28334C2.88325 1.68334 3.58881 1.20823 4.39992 0.85801C5.21103 0.508232 6.0777 0.333344 6.99992 0.333344C7.92214 0.333344 8.78881 0.508232 9.59992 0.85801C10.411 1.20823 11.1166 1.68334 11.7166 2.28334C12.3166 2.88334 12.7915 3.5889 13.1413 4.40001C13.4915 5.21112 13.6666 6.07779 13.6666 7.00001C13.6666 7.92223 13.4915 8.7889 13.1413 9.60001C12.7915 10.4111 12.3166 11.1167 11.7166 11.7167C11.1166 12.3167 10.411 12.7916 9.59992 13.1413C8.78881 13.4916 7.92214 13.6667 6.99992 13.6667ZM6.99992 12.3333C8.48881 12.3333 9.74992 11.8167 10.7833 10.7833C11.8166 9.75001 12.3333 8.4889 12.3333 7.00001C12.3333 5.51112 11.8166 4.25001 10.7833 3.21668C9.74992 2.18334 8.48881 1.66668 6.99992 1.66668C5.51103 1.66668 4.24992 2.18334 3.21658 3.21668C2.18325 4.25001 1.66659 5.51112 1.66659 7.00001C1.66659 8.4889 2.18325 9.75001 3.21658 10.7833C4.24992 11.8167 5.51103 12.3333 6.99992 12.3333Z" fill="currentColor" />
            </svg>
          </div>
        </div>
      </div>
      <div className='flex items-center justify-between'>
        <button className={`text-puffco-light-black-3 mt-6 z-50 font-mono text-xs h-[2.125rem] inlinex-flex items-center justify-between lg:px-4 before:content-[''] before:w-2 before:h-2 before:border-black before:border-l-2 before:border-t-2 before:inline-block before:mr-3 before:transform before:rotate-[-45deg] mb-5 lg:mb-0`} onClick={() => dispatch(setStep(previousStep))}>Back</button>
      </div>
    </div>
  )
}

export default Review